import { render, staticRenderFns } from "./centerMain.vue?vue&type=template&id=5534f8d2&scoped=true&"
import script from "./centerMain.vue?vue&type=script&lang=js&"
export * from "./centerMain.vue?vue&type=script&lang=js&"
import style0 from "./centerMain.vue?vue&type=style&index=0&id=5534f8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534f8d2",
  null
  
)

export default component.exports